<template>
  <div class="weather-info">
    <!--选择气象站-->
    <div class="weather-station-block">
      <weather-station ref="station" :station-list="stationList" @station-change="loadCardList"></weather-station>
    </div>
    <div class="clear weather-main" :style="mainStyle">
      <!--各种气象卡片-->
      <div class="weather-card-block" v-if="cardList.length>0">
        <weather-card :deviceType="getDeviceType(stationID)" class="weather-card-item" :is-active="activeCard===card"
                      :card-data="card" v-for="(card,index) in cardList" :bg-color="cardBgColor(index)" :key="index"
                      @click.native="handlerCardClick(card)"></weather-card>
      </div>
      <!--气象图表-->
      <div class="weather-charts-block" v-show="isShowChartBlock" v-if="cardList.length>0">
        <weather-charts :deviceType="getDeviceType(stationID)" ref="charts"></weather-charts>
      </div>
      <!--没有气象信息-->
      <div class="weather-no-data" v-if="cardList.length==0">
        <img src="/static/weather-no-data.png"/>
      </div>
    </div>
  </div>
</template>
<script>
  import weatherStation from './weather-station.vue';
  import weatherCard from './weather-card.vue';
  import weatherCharts from './weather-charts.vue';
  import resize from '../../mixins/resize';

  export default {
    components: {weatherStation, weatherCard, weatherCharts},
    mixins: [resize()],
    data() {
      return {
        stationList: [],
        activeCard: null,
        mainHeight: null,
        stationID: null,
        token: null,
        cardList: []
      };
    },
    computed: {
      mainStyle() {
        const style = {};
        if (this.mainHeight) {
          style.height = this.mainHeight + 'px';
        }
        return style;
      },
      isShowChartBlock(){
        if (this.activeCard && this.activeCard.key == 20) { //海拔高度不显示右边内容
          return false;
        }
        return true;
      }
    },
    methods: {
      cardBgColor(index) {
        let colorList = ['#3086ef', '#70aa0b', '#e96a0f', '#0d9024', '#e0a700', '#1b6ce5', '#8534dd'];
        colorList = colorList.concat(colorList).concat(colorList).concat(colorList).concat(colorList);
        return colorList[index];
      },
      //加载气象站数据
      async loadStationList() {
        const resultData = JSON.parse(localStorage.resultData);
        const Code = resultData.BatchData.Code;
        const Token = await this.getToken();
        const result = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetWeatherStationList, {Code, Token});
        if (result.Result == 200 && result.Data && result.Data.RecordList) {
          this.stationList = result.Data.RecordList;
        } else {
          this.stationList = [];
          this.cardList = [];
        }
        //-----------------
        //选中第一个气象站
        if (this.stationList[0]) {
          this.$refs.station.setActive(this.stationList[0]);
        }
      },
      async getToken() {
        if (!this.token) {
          const result = await this.$ajax.get(this.$urlAPI.BaseData.getAndroidToken);
          this.token = result.Data.token;
          setTimeout(() => {
            this.token = null;
          }, 150000);
        }
        return this.token;
      },
      cardListFormatter(deviceType, type, param, cardList) {
        const list = [];
        cardList.forEach(card => {
          if (deviceType == 2) {
            const listKeys = list.map(item => item.key * 1);
            if ((card.key == 1 || card.key == 2) && (listKeys.includes(1) || listKeys.includes(2))) {
              return;
            }
          } else {
            if (type != 1 && (!param.includes(card.key) || [103, 7, 8, 3, 37, 38, 39, 41, 42, 43].includes(card.key * 1))) {
              return;
            }
            if (type == 1 && card.key == 103) {
              return;
            }
          }
          if (isNaN(card.key)) {
            return;
          }
          list.push(card);
        });
        return list;
      },
      getType(StationID) {
        return this.stationList.find(item => item.StationID == StationID).Type;
      },
      getDeviceType(StationID) {
        return this.stationList.find(item => item.StationID == StationID).DeviceType;
      },
      //根据选择的气象站 加载卡片列表
      async loadCardList(StationID) {
        //ajax加载数据
        this.stationID = StationID;
        const type = this.getType(StationID);
        const deviceType = this.getDeviceType(StationID);
        const Token = await this.getToken();
        const params = {StationID, Token};
        if (deviceType == '2') { //左岸
          //params.DateWeather = '2018-12-18';
        }
        //console.log(deviceType);
        const result = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetLatestWeatherRecord, params);
        //console.log(result);
        if (result.Result == 200 && result.Data && result.Data.weatherData) {
          const cardList = Object.keys(result.Data.weatherData).map(key => {
            const value = result.Data.weatherData[key];
            return {key, value};
          });
          const param = result.Data.param.split(',');
          this.cardList = this.cardListFormatter(deviceType, type, param, cardList);
          //console.log(this.cardList);
        } else {
          this.cardList = [];
        }
        //------------
        //选中第一张卡片
        if (this.cardList.length > 0) {
          this.handlerCardClick(this.cardList[0]);
        }
      },
      handlerCardClick(card) {
        if (card.key == 20) { //海拔高度
          return;
        }
        this.activeCard = card;
        this.renderCharts();
      },
      //根据选择的卡片 渲染图表
      async renderCharts() {
        const token = await this.getToken();
        await this.$nextTick();
        this.$refs.charts.render(this.activeCard, this.stationID, token);
      },
      onResize() {
        this.setMainHeight();
      },
      setMainHeight() {
        const mainDom = this.$el.querySelector('.weather-main');
        if (mainDom) {
          this.mainHeight = window.innerHeight - 300;
        }
      }
    },
    mounted() {
      this.loadStationList();
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.$store.commit('setPageTitle', '气象信息');
      });
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .weather-main {
    height: 280px;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
  }

  .weather-info {
    position: relative;
    width: 95%;
    margin-left: 2.5%;
    top: 30px;
  }

  .weather-station-block {
    height: 40px;
    /*background-color: fade(#000, 30%);*/
    margin: 30px 0;
    margin-top: 0;
  }

  .weather-card-block {
    width: 46%;
    float: left;
    height: 100%;
    font-size: 0;
    .weather-card-item {
      width: 24%;
      height: 24%;
      margin-right: 1.3%;
      margin-bottom: 1.3%;
      display: inline-block;
      vertical-align: top;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .weather-charts-block {
    width: 52.8%;
    float: right;
    height: 100%;
    background-color: #fff;
    border-radius: 5px;
  }

  .weather-no-data {
    position: relative;
    text-align: center;
    height: 100%;
    background-color: #fff;
    border-radius: 5px;
    img {
      position: absolute;
      width: 176px;
      height: 180px;
      left: 50%;
      top: 50%;
      margin-left: -88px;
      margin-top: -90px;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?7ab75bd0